import { useEffect, useState , useContext } from "react";
import toast from "react-hot-toast";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import ErrorPopup from "../../common/ErrorPopup";
import FormTwo from "../formTwo/formTwo";
import styles from "./formThree.module.scss";
import apiPath from "../../../config/apiPaths.json";
import CONSTANTS from "../../../config/en-us.json";
import { hallRentalListProps } from "../../../infrastructure/GlobalContextProvider";
import {
  CommonButton,
  CommonOutlinedButton,
} from "../../common/StyledComponents/StyledFields";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormFooter from "../formFooter";
import { CMS_BASE_URL } from "../../../config/apiUrl";
import { Grid } from "@mui/material";
import { HallBookingRequestResponseContext } from "../formOne/facilityUsageAgreementForm";

interface fromThreeProps {
  updateParentState: (newState: boolean) => void;
  formData: any;
  sign: string;
  handleInputChange: any;
}

const FormThree = (props: fromThreeProps) => {
  const viewContractFormResponse = useContext(HallBookingRequestResponseContext);
  console.log(viewContractFormResponse);
  const [hallList, setHallList] = useState<hallRentalListProps[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [nextStep, setNextStep] = useState(false);
  const [html, setHTML] = useState({ __html: "" });
  const tableHallsData = [
    {
      name: "Building B-Event Halls",
      rooms: [
        {
          name: "Akella Assembly Hall with dressing rooms",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Akella Annadana Kitchen provided only if hall rented",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Chamundi (with Homa Kundal",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Lakireddy Auditorium with dressing rooms",
          usable_area: "50 x 70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
      ],
    },
    {
      name: "Building C-Event Hall and Room",
      rooms: [
        {
          name: "Tirumala (Event hall",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Palani (Event room)",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
      ],
    },
    {
      name: "Building D - Event Hall",
      rooms: [
        {
          name: "Badrinath East & West wings together",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Badrinath East wing only (with Home Kund)",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Badrinath West wing only",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
      ],
    },
    {
      name: "Building D - Event Hall",
      rooms: [
        {
          name: "Kedarnath East & West wings together",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Kedarnath East wing only",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Kedarnath West wing only",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
      ],
    },
    {
      name: "Building D - Event & Dressing  Room",
      rooms: [
        {
          name: "Gangothri (Event Room)",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Yamunothri ( Dressing room with bath)",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
        {
          name: "Sabarimala ( Dressing room with bath)",
          usable_area: "50x70",
          capacity: {
            lecture: 360,
            banquet: 240,
          },
          min_hours: 4,
          min_fees: 1400,
          hourly_fee: 350,
          furniture_setup_fee: 350,
          security_deposit: 350,
          cancellation_fees: 400,
        },
      ],
    },
  ];
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = () => {
    apiRequest({
      method: "GET",
      basePath: `${CMS_BASE_URL}`,
      includeToken: false,
      endpoint: "/wp-json/wp/v2/hccc-page",
      params: {
        slug: "facility-usage-application-p2",
      },
    })
      .then((res) => {
        console.log(res, "hem");
        const acfContent = res.data[0]?.acf?.hccc_page || "";
        setHTML({ __html: acfContent });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.hallTableInfo,
      includeToken: true,
    })
      .then((res) => {
        setHallList(res.data);
        console.log(res.data, "Event Halls");
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: 10000,
          }
        );
      });
  }, []);

  const emptyRow = () => (
    <tr>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
      <td style={{ height: "1rem" }}></td>
    </tr>
  );

  const handleClick = () => {
    props.updateParentState(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const updatedState = (newState: boolean) => {
    setNextStep(newState);
  };

  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentNumberStyle}>2</span>{" "}
      <span className={styles.totalPagesNumberStyle}>/ 9</span>
    </div>
  );

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handleClick}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={() => {
            setNextStep(true);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          Next
        </CommonButton>
      </div>
    );
  };

  const notePointsInfo = () => {
    return (
      <table>
        <tbody>
          <tr></tr>
          <tr></tr>
          <tr></tr>
          <tr>
            <b></b>
          </tr>
          <tr></tr>
          <tr></tr>
          <tr></tr>
        </tbody>
      </table>
    );
  };

  return (
    <>
      {!nextStep && (
        <div>
          <div><br/><h2 style={{textAlign:"center", color:"#882E14"}}>FACILITY USAGE AGREEMENT</h2></div>
          {/* <div
            style={{
              display: "flex",
              gap: "1rem",
              float: "right",
              marginBottom: "20px",
            }}
          >
            {navigationButtons()}
          </div> */}
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal} rowSpan={2}>
                  Event Halls and Rooms
                </th>
                <th className={styles.tableHorizontal}>Usable</th>
                <th className={styles.tableHorizontal} colSpan={2}>
                  Capacity
                </th>
                <th className={styles.tableHorizontal}>Min</th>
                <th className={styles.tableHorizontal}>Min</th>
                <th className={styles.tableHorizontal}>Hourly</th>
                <th className={styles.tableHorizontal}>Furniture</th>
                <th className={styles.tableHorizontal}>Security</th>
                <th className={styles.tableHorizontal}>Cancellation</th>
              </tr>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Area</th>
                <th className={styles.tableHorizontal}>Lecture</th>
                <th className={styles.tableHorizontal}>Banquet</th>
                <th className={styles.tableHorizontal}>Hrs</th>
                <th className={styles.tableHorizontal}>Fees</th>
                <th className={styles.tableHorizontal}>Fee</th>
                <th className={styles.tableHorizontal}>setup</th>
                <th className={styles.tableHorizontal}>Deposit</th>
                <th className={styles.tableHorizontal}>Fee</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {hallList.map((venue) => {
                return (
                  <>
                    {emptyRow()}
                    <tr className={styles.tableRow}>
                      <td className={styles.headingRows} colSpan={10}>
                        {venue.category}
                      </td>
                    </tr>
                    {venue.eventHalls.map((item: any) => (
                      <tr key={item.name}>
                        <td className={styles.tableDiagonal}>
                          {item.description}
                        </td>
                        <td className={styles.tableDiagonal}>{item.area}</td>
                        <td className={styles.tableDiagonal}>
                          {item.hallCapacity.capacity}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.hallCapacity.banquetCapacity}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.minimumHours}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.minimumFee}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.hourlyFee}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.setupAndCleaning}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.securityDeposit}
                        </td>
                        <td className={styles.tableDiagonal}>
                          {item.cancellationFee}
                        </td>
                      </tr>
                    ))}
                  </>
                );
              })}
            </tbody>
          </table>
          {/* {notePointsInfo()} */}
          <Grid sx={{mt: 3}}>
          <div dangerouslySetInnerHTML={html} />
          </Grid>
          <FormFooter
            sign={props.sign}
            handleInputChange={props.handleInputChange}
            navigationButtons={navigationButtons()}
          />
        </div>
      )}

      {nextStep && (
        <FormTwo
          sign={props.sign}
          handleInputChange={props.handleInputChange}
          updateParentState={updatedState}
          formData={props.formData}
          hallList={hallList}
        />
      )}
    </>
  );
};

export default FormThree;
